module.exports = __webpack_public_path__ + "static/media/icon-ivm.52402847.svg";